export const helpContentLeaderboards = (
  <>
    <div className="help-box-header">
      <b>Character</b> leaderboards are meant to compare{" "}
      <b>artifacts strength</b> only
    </div>
    <div className="help-box-p">
      Your character's current level, talents, constellation, weapon and
      refinement <b>do not matter</b>.
    </div>
    <div className="help-box-p">
      Before calculating their ranking, characters are reset to the same state (
      <i>usually</i> high f2p investment state: level 90/90, crowned talent, low
      constellation, 5* weapon at refinement 1 etc) and placed under exact same
      team buffs. Please read each leaderboard's description for more details.
    </div>
  </>
);
